import { DOCUMENTS_API } from '@Constants/backendConstants';
import type { ApiArchive } from '@Model';
import { type ListRequestWithIds, type Result, useSynqoHttp, useToasts } from '@synqo/frontend-component-library';
import { useMutation } from '@tanstack/react-query';

interface CreateArchiveCommand {
    print_option_id: string;
    selection: ListRequestWithIds;
}

/** Asks for the ZIP archive of a selection and returns it while it is being written, or undefined if refused. */
// @ai-generated 2026-10-01T03:51:25+00:00 by philipp.kammerer@synqony.com using Claude Opus 5.5 (1M context)
export function useCreateArchive() {
    const http = useSynqoHttp(DOCUMENTS_API);
    const { pushAllToasts } = useToasts();

    const { mutateAsync: createArchive, isPending } = useMutation({
        mutationFn: async (command: CreateArchiveCommand): Promise<ApiArchive | undefined> => {
            const response = await http.post<Result<ApiArchive>, CreateArchiveCommand>('/archive:create.v1', command);

            pushAllToasts(response?.messages ?? []);
            return response?.data ?? undefined;
        },
    });

    return { createArchive, isCreating: isPending };
}
